import { motion } from "framer-motion";

const PATH =
  "M360.83 137.997C369.396 138.078 377.942 140.971 384.994 146.677L632.313 346.815L632.358 346.851L632.403 346.888L635.067 349.13C661.176 371.104 648.221 412.418 616.491 417.46C616.429 418.957 616.062 420.466 615.352 421.894L539.046 575.402C534.339 584.871 520.897 585.058 515.928 575.724L439.677 432.478L359.505 478.8C354.245 481.839 347.517 480.039 344.477 474.779C341.438 469.518 343.239 462.791 348.499 459.751L426.073 414.93C417.324 402.544 405.161 392.891 390.998 387.199C374.591 380.604 356.446 379.704 339.467 384.641C322.488 389.578 307.654 400.068 297.34 414.432C287.025 428.797 281.826 446.206 282.573 463.875C283.32 481.545 289.972 498.453 301.463 511.895C312.953 525.337 328.62 534.536 345.956 538.021C363.291 541.506 381.294 539.076 397.086 531.12L397.824 530.743C413.272 522.755 425.662 509.888 433.061 494.13C435.996 487.882 443.44 485.194 449.689 488.128C455.938 491.063 458.624 498.507 455.69 504.756C445.796 525.827 429.123 542.972 408.336 553.446C387.548 563.92 363.848 567.118 341.028 562.531C318.208 557.943 297.585 545.834 282.46 528.14C278.521 523.533 275.016 518.615 271.966 513.452C255.623 547.22 221.033 570.51 181.002 570.51C125.221 570.51 80.0018 525.291 80.0017 469.51C80.0017 449.589 85.7699 431.015 95.7263 415.367C69.8588 405.4 61.1186 369.199 84.9646 349.13L87.6287 346.888L87.6736 346.851L87.7185 346.815L335.038 146.677C342.089 140.971 350.635 138.079 359.201 137.997H360.83ZM360.03 149.998V149.999C360.025 149.999 360.02 149.999 360.015 149.998C360.011 149.999 360.006 149.999 360.002 149.999V149.998C353.843 149.901 347.657 151.903 342.587 156.005L95.3093 356.108L92.6912 358.311C75.2816 372.963 82.9611 400.035 103.177 405.129C121.703 382.76 149.688 368.51 181.002 368.51C209.706 368.51 235.614 380.485 254.002 399.711V283.51H277.002V399.895C277.012 399.88 277.023 399.866 277.033 399.851C290.61 380.943 310.136 367.134 332.487 360.635C354.838 354.136 378.723 355.322 400.321 364.002C421.919 372.683 439.981 388.357 451.619 408.517C451.939 409.072 452.211 409.641 452.438 410.22C452.837 410.698 453.204 411.215 453.526 411.773C453.832 412.302 454.086 412.847 454.295 413.4C454.632 413.849 454.939 414.33 455.212 414.841L527.13 549.948L592.735 417.969H564.649C561.336 417.969 558.649 415.283 558.649 411.969C558.65 408.656 561.336 405.969 564.649 405.969H609.955C635.142 405.968 646.611 374.529 627.341 358.311L624.722 356.108L377.445 156.005C372.375 151.903 366.189 149.901 360.03 149.998ZM181.002 393.51C139.028 393.51 105.002 427.537 105.002 469.51C105.002 511.484 139.028 545.51 181.002 545.51C222.975 545.51 257.002 511.484 257.002 469.51C257.002 427.537 222.975 393.51 181.002 393.51Z";

export default function AnimatedLogo({ style = {} }) {
  return (
    <motion.div
      style={{ display: "inline-flex", ...style }}
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <motion.svg
        width="100%"
        height="100%"
        viewBox="0 0 720 720"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        animate={{ y: [0, -15, 0] }}
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      >
        <defs>
          <filter id="glowHero" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="20" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
          <linearGradient
            id="heroGradient"
            x1="80"
            y1="138"
            x2="661"
            y2="585"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ffffff" />
            <stop offset="1" stopColor="#a5c8ff" />
          </linearGradient>
        </defs>
        <motion.path
          d={PATH}
          stroke="url(#heroGradient)"
          strokeWidth="4"
          fill="url(#heroGradient)"
          filter="url(#glowHero)"
          initial={{ pathLength: 0, fillOpacity: 0 }}
          animate={{ pathLength: 1, fillOpacity: 1 }}
          transition={{
            pathLength: { duration: 2.5, ease: "easeInOut" },
            fillOpacity: { duration: 1.5, delay: 2, ease: "easeIn" },
          }}
        />
      </motion.svg>
    </motion.div>
  );
}
